import { __decorate, __metadata } from "tslib";
// deep imports to fix circular deps in jest
import { AppRequest } from '../../app-request';
import { Expose, Model, ModelId } from '../../model';
import { AppRequestMethod } from '../../request';
let GetSessionInfoResponse = /*#__PURE__*/(() => {
  let GetSessionInfoResponse = class GetSessionInfoResponse extends Model {};
  __decorate([Expose(), __metadata("design:type", Object)], GetSessionInfoResponse.prototype, "sessionInfo", void 0);
  GetSessionInfoResponse = __decorate([ModelId("GetSessionInfoResponse") // auto-generated by generate-model-ids
  ], GetSessionInfoResponse);
  return GetSessionInfoResponse;
})();
export { GetSessionInfoResponse };
let GetSessionInfoRequest = /*#__PURE__*/(() => {
  let GetSessionInfoRequest = class GetSessionInfoRequest extends Model {
    static {
      this.Response = GetSessionInfoResponse;
    }
  };
  __decorate([Expose(), __metadata("design:type", Boolean)], GetSessionInfoRequest.prototype, "reload", void 0);
  GetSessionInfoRequest = __decorate([AppRequest('access', 'session', {
    httpMethod: AppRequestMethod.POST,
    disallowInternal: true
  }), ModelId("GetSessionInfoRequest") // auto-generated by generate-model-ids
  ], GetSessionInfoRequest);
  return GetSessionInfoRequest;
})();
export { GetSessionInfoRequest };
let FindSessionItemsInternalResponse = /*#__PURE__*/(() => {
  let FindSessionItemsInternalResponse = class FindSessionItemsInternalResponse extends Model {};
  __decorate([Expose(), __metadata("design:type", Array)], FindSessionItemsInternalResponse.prototype, "items", void 0);
  FindSessionItemsInternalResponse = __decorate([ModelId("FindSessionItemsInternalResponse") // auto-generated by generate-model-ids
  ], FindSessionItemsInternalResponse);
  return FindSessionItemsInternalResponse;
})();
export { FindSessionItemsInternalResponse };
let FindSessionItemsInternalRequest = /*#__PURE__*/(() => {
  let FindSessionItemsInternalRequest = class FindSessionItemsInternalRequest extends Model {
    static {
      this.Response = FindSessionItemsInternalResponse;
    }
  };
  __decorate([Expose(), __metadata("design:type", String)], FindSessionItemsInternalRequest.prototype, "authType", void 0);
  __decorate([Expose(), __metadata("design:type", Object)], FindSessionItemsInternalRequest.prototype, "authId", void 0);
  FindSessionItemsInternalRequest = __decorate([AppRequest('access', 'sessions-internal', {
    httpMethod: false
  }), ModelId("FindSessionItemsInternalRequest") // auto-generated by generate-model-ids
  ], FindSessionItemsInternalRequest);
  return FindSessionItemsInternalRequest;
})();
export { FindSessionItemsInternalRequest };